import { createClient } from '@/lib/supabase/client';

export interface DailyResponse {
  id?: string;
  day_number: number;
  day_title: string;
  response_type: 'scenario' | 'ritual';
  scenario_id?: number | null;
  scenario_context?: string | null;
  ritual_time?: string | null;
  journal_entry: string;
  completed: boolean;
  participant_name?: string;
  submitted_at?: string;
  created_at?: string;
}

export async function saveDailyResponse(
  payload: Omit<DailyResponse, 'id' | 'created_at' | 'submitted_at'>
): Promise<{ data: DailyResponse | null; error: string | null }> {
  const supabase = createClient();
  const { data, error } = await supabase
    .from('daily_responses')
    .insert([payload])
    .select()
    .single();

  if (error) return { data: null, error: error.message };
  return { data: data as DailyResponse, error: null };
}

export async function fetchTodayResponses(dayNumber: number): Promise<DailyResponse[]> {
  const supabase = createClient();
  const { data, error } = await supabase
    .from('daily_responses')
    .select('*')
    .eq('day_number', dayNumber)
    .order('submitted_at', { ascending: false });

  if (error) return [];
  return (data as DailyResponse[]) ?? [];
}

export async function fetchAllResponses(): Promise<DailyResponse[]> {
  const supabase = createClient();
  const { data, error } = await supabase
    .from('daily_responses')
    .select('*')
    .order('submitted_at', { ascending: false });

  if (error) return [];
  return (data as DailyResponse[]) ?? [];
}
